import React, { useEffect } from 'react';
import { Form, Input, Checkbox, Select } from 'antd';
import FormLabel from 'components/FormLabel';
import { GLOBAL_PERMISSIONS, ACCOUNT_PERMISSIONS, DATA_SOURCE_PERMISSIONS } from 'shared/constants/permissions';
import globalMessages from 'translations/messages';
import { RoleType } from 'shared/services/prisma/types';
import RoleTypeLabel from 'components/RoleTypeLabel';
import messages from './messages';

const permissions = {
  INTERNAL: GLOBAL_PERMISSIONS,
  CUSTOMER: ACCOUNT_PERMISSIONS,
  DATA_SOURCE: DATA_SOURCE_PERMISSIONS,
};

const UpsertRoleForm = ({ form, onSubmit, role = {} }) => {
  useEffect(() => form.resetFields(), [role]);
  const roleType = Form.useWatch('roleType', form) || role.roleType;

  const onFinish = (values) => {
    onSubmit(role.id, values);
  };

  return (
    <Form
      layout="vertical"
      form={form}
      onFinish={onFinish}
      initialValues={role}

    >
      <Form.Item
        name="name"
        label={<FormLabel label={globalMessages.name} />}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="roleType"
        label={<FormLabel label={globalMessages.type} />}
        rules={[{ required: true }]}
      >
        <Select>
          {Object.values(RoleType).map((type) => (
            <Select.Option key={type} value={type}><RoleTypeLabel roleType={type} /></Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        name="description"
        label={<FormLabel label={globalMessages.description} />}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="visible"
        valuePropName="checked"
      >
        <Checkbox defaultChecked><FormLabel label={messages.visible} /></Checkbox>
      </Form.Item>

      <Form.Item
        name="permissions"
        label={<FormLabel label={messages.permissions} />}
      >
        <Checkbox.Group>
          {Object.values(permissions[roleType] || {}).map((permission) => (
            <Checkbox key={permission} value={permission} style={{ width: '100%' }}>
              {permission}
            </Checkbox>
          ))}
        </Checkbox.Group>
      </Form.Item>
    </Form>
  );
};

export default UpsertRoleForm;
